<template>
<div class="chapter">
<div class="inner_page">
<p class="part11">The Witches of London Trilogy</p>
<p class="part11b">The Secret Witch, The Whisper Witch, and The Bone Witch</p>
<p class="author">Alyxandra Harvey</p>
<div class="img_container4">
<img alt="Image" src="Book1/images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bundle_title.vue?5f83cc06